import * as THREE from 'three';

/**
 * VIS-22-остаток: СЕЛЕКТИВНЫЙ BLOOM ПО EMISSIVE.
 *
 * Пороговый bloom (0.93) честно не цветёт товаром, но всё ещё ловит яркие
 * блики и засветку. Селективный режим рисует bloom ТОЛЬКО для emissive-слоя:
 *
 *   bloomComposer: [RenderPass(camera.layers = EMISSIVE_LAYER) → UnrealBloom]
 *   main composer: [renderPass → ssao → bloom(выкл при селективе) →
 *                   AddSelectiveGlowPass(glow-текстура) → output → smaa]
 *
 * Слой тегируется при рождении emissive-материала (enableEmissiveBloomLayer).
 * Текстура свечения подмешивается аддитивно отдельным шейдер-пасом — кадр
 * остаётся честным (товар не светится), светится источник.
 */

export const EMISSIVE_BLOOM_LAYER = 1;

/** Пометить меш как источник свечения для селективного bloom. */
export function enableEmissiveBloomLayer(mesh: THREE.Object3D): void {
  mesh.layers.enable(EMISSIVE_BLOOM_LAYER);
}

/** Шейдер аддитивной подмеси glow-текстуры в готовый кадр. */
export const SelectiveGlowShader = {
  uniforms: {
    /* tDiffuse подставляет ShaderPass (readBuffer основного композера). */
    tDiffuse: { value: null as THREE.Texture | null },
    tGlow: { value: null as THREE.Texture | null },
    glowStrength: { value: 1.0 },
  },
  vertexShader: /* glsl */ `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: /* glsl */ `
    uniform sampler2D tDiffuse;
    uniform sampler2D tGlow;
    uniform float glowStrength;
    varying vec2 vUv;
    void main() {
      vec4 base = texture2D(tDiffuse, vUv);
      vec4 glow = texture2D(tGlow, vUv);
      /* АДДИТИВНО (аудит III, C3): свечение ПРИБАВЛЯЕТСЯ к кадру;
         NormalBlending+opaque у ShaderMaterial выключил бы блендинг вовсе. */
      gl_FragColor = vec4(base.rgb + glow.rgb * glowStrength, base.a);
    }
  `,
} as const;
